import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TransactionData = {
  code: string;
  id: string;
};

export interface DepositModaleState {
  transactionData: TransactionData;
}

const initialState: DepositModaleState = {
  transactionData: {
    code: "",
    id: "",
  },
};

export interface HeaderTabs {
  title: string;
  path: string;
}

const depositModalSlice = createSlice({
  name: "depositModal",
  initialState: initialState,
  reducers: {
    // The DepositCryptoModal can render intermittently due to page recalling endpoints. Save the token code and address so that when a user submits the manual form it doesnt error out due to missing code and address
    setTransactionData: (
      state: DepositModaleState,
      action: PayloadAction<TransactionData>,
    ): void => {
      state.transactionData = action.payload;
    },
  },
});

export const { setTransactionData } = depositModalSlice.actions;

export default depositModalSlice;
